import React, {ReactElement} from "react"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import LogoIcon from "@ui/icons/LogoWithText"
import Login from "./Login"

const Auth = (): ReactElement => {
  const {settings} = useStore()

  return (
    <div className="auth">
      {settings.isDesktop && <div className="auth-img"></div>}
      <div className="form">
        <div className="logo">
          <LogoIcon/>
        </div>
        <Login/>
        <div className="footer secondary-header-text">
          <span>
            {t("auth.eula.text")}
            <a target="_blank" href="/rules">{t("auth.eula.link")}</a>
          </span>
        </div>
      </div>
    </div>
  )
}

export default Auth
